import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import queryClient from '../query-client';

async function refreshJournals(workpaperId: string): Promise<{ updated: number }> {
    const { data } = await api.post(`/workpapers/${workpaperId}/journals/refresh`);
    return data;
}

export function useRefreshJournals(): UseMutationResult<{ updated: number }, AxiosError, string, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation(() => refreshJournals(workpaperId), {
        onSettled: () => {
            queryClient.invalidateQueries(['journals']);
            queryClient.invalidateQueries(['worksheets']);
            queryClient.invalidateQueries(['workpapers', workpaperId]);
        },
    });
}
